export class ToastMessage {
    public message: string;
    public gotoButtonText: string;
}
